export enum AccountSettingsTabEnum {
  Team = 'team',
  Security = 'security',
  Plan = 'plan',
}
